import * as React from "react";
import Note from "../../../model/note/Note";
import DateUtils from "../../../utils/DateUtils";
import Toast from "../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Option} from "ts-option";
import {Dispatch} from "redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {connect} from "react-redux";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import {RootState} from "../../../store/reducer/root/RootState";
import UserMention from "../../mention/UserMention";
import {modifyPinningOnLeadNote} from "../../../store/action/note/notes";

interface ComponentProps {
	/**
	 * Lead id
	 */
	leadId: Option<string>;
	/**
	 * Pinned notes
	 */
	notes: Note[]
}

interface ReduxProps {
	/**
	 * Logged user id
	 */
	loggedUserId: string
}

interface DispatchProps {
	/**
	 * Pin / unpin note action
	 * @param {string} noteId
	 * @param {string} leadId
	 * @param {boolean} pinned
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	modifyPinningOnLeadNote: (noteId: string, leadId: string, pinned: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = ComponentProps & DispatchProps & ReduxProps;

class LeadPinnedNotes extends React.PureComponent<Props> {

	render() {
		return (
			this.props.notes.length > 0 &&
			<div className="pinned-notes-wrapper">
				{this.props.notes.map((note) =>
				<div key={note.id} className="pinned-notes">
					<div className="dot">
						<div className="circle"></div>
					</div>
					<div className="content">
						<div>
							<UserMention value={note.extendedContent} readonly/>
						</div>
						<div className="footer">
							<span className="caption">Pinned by {note.pinningData.getUserDisplayName()} {note.pinningData.getCreationDate().map(date => date.format(DateUtils.DATE_TIME_FORMAT)).orNull}</span>
							<ButtonTertiary label={'View in timeline'} onClick={() => this.scrollToNote(note.id)} />
							{note.pinningData.userWhoPinned.map(u => u.id).orNull === this.props.loggedUserId &&
							<span> &bull; <ButtonTertiary label={'Un-pin'} onClick={() => this.unpinNoteClick(note.id)}/></span>
							}
						</div>
					</div>
				</div>
				)}
			</div>
		);
	}

	unpinNoteClick(noteId:string) {
		this.props.modifyPinningOnLeadNote(noteId, this.props.leadId.getOrElse(''), false,
			() => Toast.success("Note unpinned successfully.", "Unpin note"),
			(err) => notifyBugsnagAndShowToast(err, 'Unpin note'));
	}

	scrollToNote(noteId:string) {
		document.getElementById(noteId).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
	}
}

function mapStateToProps(state: RootState) {
	return {
		loggedUserId: state.user.user.get.id
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		modifyPinningOnLeadNote: (noteId: string, leadId: string, pinned: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			modifyPinningOnLeadNote(noteId, leadId, pinned, onSuccess, onFailure)
		)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadPinnedNotes);